import { render, staticRenderFns } from "./Cart.vue?vue&type=template&id=67fabb27&scoped=true"
import script from "./Cart.vue?vue&type=script&lang=js"
export * from "./Cart.vue?vue&type=script&lang=js"
import style0 from "./Cart.vue?vue&type=style&index=0&id=67fabb27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fabb27",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DescriptionProduct: require('/home/luiz/Sistemas/loja/components/DescriptionProduct.vue').default,CupomCart: require('/home/luiz/Sistemas/loja/components/CupomCart.vue').default})
